import { Block, Inline, INLINES, Text } from '@contentful/rich-text-types'
import { CitationProgrammaticPageShortcode } from './citation-programmatic-shortcode'
import { CodeName, isCitationProgrammaticPageShortcodeName, isInlineIconCodeName } from './types'
import { InlineIconCodeName } from './inline-icon-shortcode'
import { ComponentContentTypes } from '../../../../lib/types/content-types'

export const getShortcodeName = (inline: Inline): CodeName => {
  return inline.data.target.fields.codeName
}

interface ShortcodeProps {
  codeName: CodeName
}

export const Shortcode = (props: ShortcodeProps) => {
  if (isCitationProgrammaticPageShortcodeName(props.codeName)) {
    return <CitationProgrammaticPageShortcode codeName={props.codeName} />
  } else if (isInlineIconCodeName(props.codeName)) {
    return <InlineIconCodeName codeName={props.codeName} />
  }

  return null
}

export const isShortcode = (inline: Block | Inline | Text): boolean => {
  return (
    inline.nodeType === INLINES.EMBEDDED_ENTRY &&
    inline.data?.target?.sys?.contentType?.sys?.id === ComponentContentTypes.ItemShortcode
  )
}
